import { styled } from '@vw-marketing/us-components';

interface WrapperProps {
  readonly videoMaxWidth?: string;
  readonly videoWidth?: string;
  readonly videoMargin?: string;
}

export const Wrapper = styled.div<WrapperProps>`
  display: block;
  width: ${(props: WrapperProps) =>
    props.videoWidth ? props.videoWidth : '100%'};
  max-width: ${(props: WrapperProps) =>
    props.videoMaxWidth ? props.videoMaxWidth : ''};
  margin: ${(props: WrapperProps) =>
    props.videoMargin ? props.videoMargin : 'auto'};

  /* Responsive video player */
  div:nth-child(1) {
    /* wrapper of the iframe generated */
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;

    .youtubeContainer {
      /* iframe class we assigned a className */
      position: absolute;
      top: 0;
      border: 0;
      height: 100%;
      width: 100%;
    }
  }
`;
